import { render, staticRenderFns } from "./FuelStorageStockBalance.vue?vue&type=template&id=23673b40&scoped=true&"
import script from "./FuelStorageStockBalance.vue?vue&type=script&lang=js&"
export * from "./FuelStorageStockBalance.vue?vue&type=script&lang=js&"
import style0 from "./FuelStorageStockBalance.vue?vue&type=style&index=0&id=23673b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23673b40",
  null
  
)

export default component.exports